import { SelectionType } from 'app/constants/selectionType'

export const getSelectionTypeIcon = (type: SelectionType): string => {
  let icon = null

  switch (type) {
    case SelectionType.BEGIN:
      icon = 'Poczatek_zaznaczenia'
      break
    case SelectionType.END:
      icon = 'Koniec_zaznaczenia'
      break
    default:
      icon = 'Start_zaznaczenia'
      break
  }

  return icon
}
